import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/prices', request)
}

export {get}
